import { useQuery } from '@tanstack/react-query';
import { authenticatedApi } from '../api';

export interface SavV2Counts {
  unassigned: number;
  mySavs: number;
  searchingRepairer: number;
  waitingQuoteBeneficiary: number;
  waitingQuoteManager: number;
  transcribingQuote: number;
  analyzingQuote: number;
  formalizingDecision: number;
  refusedGarant: number;
  directCoverage: number;
  waitingGarantSignature: number;
  waitingBeneficiarySignature: number;
  newBeneficiaryMessages: number;
  newInternalMessages: number;
  newGarantMessages: number;
  // Cycle paiement réparateur (cf SPECS/repairer_payment Phase 6)
  waitingRepairerInvoiceUpload?: number;
  waitingGarantPayment?: number;
  // Escalades sidebar Bloc 5.4 : matérialisées comme statuts virtuels,
  // pas comme emails internes. Gestionnaire les voit sous "Action requise".
  paymentOverdueGarant?: number;
  repairerUploadOverdue?: number;
  paymentDisputeToTreat?: number;
  // Action gestionnaire requise (Bloc 5.1) : SAV avec paymentCycleEnabled=true
  // mais réparateur attribué sans email (impossible d'envoyer OTP + lien).
  repairerNoEmailActionRequired?: number;
}

/**
 * Hook pour récupérer les counts des filtres SAV v2
 * Utilisé pour afficher les badges dans la sidebar
 *
 * @param managerFilter - Filtre optionnel par gestionnaire ('my-savs', 'unassigned', UUID du gestionnaire, ou undefined pour tous)
 */
export function useSavV2Counts(managerFilter?: string) {
  const { data: counts, refetch, isLoading, error } = useQuery<SavV2Counts>({
    queryKey: ['sav-v2-counts', managerFilter],
    queryFn: async () => {
      const response = await authenticatedApi.get<SavV2Counts>('/sav-v2/filtered-list/counts', {
        params: managerFilter ? { managerFilter } : undefined,
      });
      return response.data;
    },
  });

  return {
    counts,
    refetch,
    isLoading,
    error,
  };
}
